// import Vue from 'vue'

const getters = {
  getRobots: ({
    robots
  }) =>
    robots,

  getCurrentRobot: ({
    currentRobot
  }) =>
    currentRobot,

  getEventRobotCount: ({ eventRobotCount }) => eventRobotCount
}

export default getters
